module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/games/games.component.scss
// module id = ./src/app/games/games.component.scss
// module chunks = main